import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";
import moment from "moment";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../constants"

// Assets
import Package from "../../images/package.png";

// Define Interface
type Props = {
  className?: string;
  img?: string;
  tracking: Array<{status: string; description: string, created_at: Date}>
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  .location-card{
    width: 100%;
    display: flex;
    position: relative;
    padding-bottom: 32px;
    .track-line{
      border: 1px dashed #bebebe;
      position: absolute;
      top: 0;
      left: 16px;
      height: 84px;
    }
    .tracking-icon{
      width: 32px;
      height: 32px;
      object-fit: contain;
      margin-right: 16px;
    }
    .location-info-wrapper{
      .location-text{
        font-family: ${props => props.fontFamilyBold};
        font-size: 12px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #242424;
        margin-bottom: 8px;
      }
      .date-text{
        font-family: ${props => props.fontFamilyRegular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #242424;
        margin-bottom: 0;
      }
    }

    &.passed{
      .tracking-icon{
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
      }
    }

    &.last-item{
      padding-bottom: 0;
    }
  }
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}


const TrackingNumber: FC<Props> = ({
  className,
  img,
  tracking
}) => {
  const renderDate = (date) => moment(date).format("MMM DD, YYYY LT")

  return (
    <StyledComponent className={className}>
      {
        tracking?.length ? tracking.map((item, idx) => {
          const passedLocation = idx > 0 ? "passed" : "";
          const lastItem = idx === tracking?.length - 1;
          return (
            <div key={idx} className={`location-card ${passedLocation} ${lastItem ? "last-item" : ""}`}>
              {lastItem ? null : <div className="track-line" />}
              <KickImage src={img || Package} alt="icon" className="tracking-icon" />
              <div className="location-info-wrapper">
                <p className="location-text">{item.status}</p>
                <p className="date-text">{item.description}</p>
                <p className="date-text">{renderDate(item.created_at)}</p>
              </div>
            </div>
          )
        }) : null
      }
    </StyledComponent>
  )
}
TrackingNumber.defaultProps = {
  className: "",
  img: ""
}

export default TrackingNumber